import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from '@mottu-ops/keycloak-angular';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '@mottu-ops/sso';
import { AccessDeniedModalComponent, FLEET_ACCESS_DENIED_ENUM } from 'src/app/shared/components/access-denied-modal/access-denied-modal.component';

@Injectable({
	providedIn: 'root',
})
export class FleetAccessGuard extends KeycloakAuthGuard {
	constructor(
		protected override readonly router: Router,
		protected readonly keycloak: KeycloakService,
		protected readonly authService: AuthService,
		private dialog: MatDialog
	) {
		super(router, keycloak);
	}

	public async isAccessAllowed(
		_route: ActivatedRouteSnapshot,
		_state: RouterStateSnapshot
	): Promise<boolean | UrlTree> {
		if (!this.authenticated) {
			await this.keycloak.login({
				redirectUri: window.location.href,
			});
			return false;
		}

		const waitForRoles = async (retries = 10, delayMs = 300): Promise<void> => {
			while (retries > 0) {
				const roles = this.authService?.credentials?.userInfo?.realmAccess?.roles;
				if (roles && roles.length > 0) {
					return;
				}
				await new Promise(resolve => setTimeout(resolve, delayMs));
				retries--;
			}
		};

		await waitForRoles();
    
		const hasFleetAccess = this.authService.validateRoles(['fleet-monitor-access'], 'or');
		if (!hasFleetAccess) {
			this.dialog.open(AccessDeniedModalComponent, {
				width: '400px',
				disableClose: true,
				autoFocus: false,
				panelClass: 'backdropAccessDenied',
				data: FLEET_ACCESS_DENIED_ENUM.FLEET_MONITOR_ACCESS
			});
			return false;
		}

		return true;
	}
}
